import api from './api';

export const listingService = {
    async list(params = {}) {
        const response = await api.get('/listings', { params });
        return response.data;
    },
    async get(id) {
        const response = await api.get(`/listings/${id}`);
        return response.data;
    },
    async create(body) {
        const response = await api.post('/listings', body);
        return response.data;
    },
    async update(id, body) {
        const response = await api.patch(`/listings/${id}`, body);
        return response.data;
    },
    async relist(id) {
        const response = await api.patch(`/listings/${id}`, {
            action: 'relist',
        });
        return response.data;
    },
    async remove(id) {
        const response = await api.patch(`/listings/${id}`, {
            action: 'remove',
        });
        return response.data;
    },
    // Completion closes the listing and is the only transition either party
    // may make, so it is a route of its own rather than a PATCH action.
    async complete(id, outcome) {
        const response = await api.post(`/listings/${id}/complete`, {
            outcome,
        });
        return response.data;
    },
    async release(id) {
        const response = await api.patch(`/listings/${id}`, {
            action: 'release',
        });
        return response.data;
    },
    // Emailed to the owner with Reply-To set to the asker; nothing is stored
    // but a count toward the daily limit, which answers 429.
    async askQuestion(id, question) {
        const response = await api.post(`/listings/${id}/questions`, {
            question,
        });
        return response.data;
    },
    async addPhotos(id, files) {
        const form = new FormData();
        for (const file of files) {
            form.append('photos', file);
        }
        const response = await api.post(`/listings/${id}/photos`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },
    async removePhoto(id, photoId) {
        const response = await api.delete(`/listings/${id}/photos/${photoId}`);
        return response.data;
    },
};

export default listingService;
